import { DesigntimeComponent } from './DesigntimeComponent.js'
import * as $ from 'jquery';

class Checkbox extends DesigntimeComponent {
    static staticName = "Checkbox (Testing)";
    static staticId = "checkbox";

    runtimeValue = false;

    constructor(identifyer) {
        super(identifyer, 1);
        this.values = {
            checkboxText: { value: "Default text" },
            buttontext: { value: "Next" }
        };
    }

    getRuntimeView(context) {
        var view = $("<div></div>");

        var $checkbox = $("<input type='checkbox'>" + this.values.checkboxText.value + "<br />");
        $checkbox.change(function (e) {
            this.runtimeValue = $(e.currentTarget).prop("checked");
        }.bind(this));

        view.append($checkbox);
        return view;
    }

    getOutput() {
        return {
            checked: this.runtimeValue,
            not_checked: !this.runtimeValue
        };
    }

    output = [
        { name: "checked", type: "bool" },
        { name: "not_checked", type: "bool" }]

}

export { Checkbox }
